export const MP3Sounds = [
    "alert-info-1",
    "alert-info-2",
    "alert-info-3",
    "alert-info-4",
    "alert-info-5",
    "beyond-doubt-2",
    "filling-your-inbox",
    "long-expected",
    "oh-finally"]
